<template>
  <div class="dwell-time__container">
    <div class="dwell-time__icon">
      <IconTime />
    </div>
    <div class="dwell-time__time">
      <div v-if="hasHours">
        <div class="widget__bignumber">{{ timeFormatted.hours }}h</div>
        <div class="widget__label widget__label-thin">Hour(s)</div>
      </div>
      <div v-if="hasHours" class="widget__bignumber divider">:</div>
      <div v-if="hasMins">
        <div class="widget__bignumber">{{ timeFormatted.mins }}m</div>
        <div class="widget__label widget__label-thin">Minute(s)</div>
      </div>
      <div v-if="hasMins" class="widget__bignumber divider">:</div>
      <div>
        <div class="widget__bignumber">{{ timeFormatted.secs }}s</div>
        <div class="widget__label widget__label-thin">Second(s)</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import IconTime from '@/icons/analytics/IconTime.svg?component';
import { secToMinHrSec } from '@/utils/formatTimeSpent';

const props = defineProps<{
  time: number;
}>();

const timeFormatted = computed(() => secToMinHrSec(props.time));

const hasHours = computed(() => {
  return timeFormatted.value.hours > 0;
});

const hasMins = computed(() => {
  return timeFormatted.value.mins > 0 || hasHours.value;
});
</script>
